import { useEffect, useState } from "react";
import { useGetQuery } from "hooks";
import { useSocket } from "providers";
import { useParams } from "react-router-dom";
import { Page, Panel, Row } from "./components";

export const Dash = () => {
  const [panels, setPanels] = useState([]);
  const { id } = useParams();
  const sock = useSocket();
  const { data } = useGetQuery({ url: `/queue/${id}` });

  useEffect(() => {
    if (!data) return;
    setPanels(
      [...(data?.queue?.QueueItems || [])].sort(
        (a, b) => a.details.slot - b.details.slot
      )
    );
  }, [data]);

  useEffect(() => {
    const onRefresh = (msg) => {
      if (msg.type === "dash") document.location.reload();
    };
    sock.on("refresh", onRefresh);
    return () => sock.off("refresh", onRefresh);
  }, [sock]);

  // Panels are keyed by slot: the queue items array is sparse when slots are empty
  const bySlot = (slot) => panels.find((p) => p.details.slot === slot);

  return (
    <Page>
      <Row>
        {[0, 1, 2].map((slot) => (
          <Panel panel={bySlot(slot)} key={bySlot(slot)?.id || slot} />
        ))}
      </Row>
      <Row>
        {[3, 4].map((slot) => (
          <Panel panel={bySlot(slot)} key={bySlot(slot)?.id || slot} />
        ))}
      </Row>
    </Page>
  );
};
